import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Label,
  Spinner,
} from "reactstrap";


import { AvForm, AvField } from "availity-reactstrap-validation";
// Redux
import { connect } from "react-redux";
import {  withRouter } from "react-router-dom";

import moment from "moment";
import { postSubmitForm } from "../../../../helpers/forms_helper";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import showNotification from "../../../../helpers/show_notification";
import { formatUnitsForReport, GetUpdatedDelivered } from "../../../../helpers/units";
import EnterQuantityForManualInventory from "../../../../components/EnterQuantityForManualInventory";
import UpdateQuantityForManualInventory from "../../../../components/UpdateQuantityForManualInventory";
import preloader from "../../../../helpers/preloader";
const animatedComponents = makeAnimated();

const AddInventory = (props) => {
  const store_id = localStorage.getItem("store_id")

  useEffect(() => {
    loadAllItems();
    if (props.selectedItem) {
      setSelectedItem(props.selectedItem);
      setSelectUnitModal(!selectUnitModal)
    }
  }, []);


  const [currentDate] = useState(() => {
    var d1 = new Date();
    var d = moment(d1).add(1, "days").toDate();
    var month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  });
  const refContainer = useRef(null);
  const refSelectItem = useRef(null);
  const [isLoading , setIsLoading] = useState(false)
  const handleValidSubmit = async (e, v) => {
    try {
      setIsLoading(true)
      let data_to_send = {};

      data_to_send.store_id = store_id;
      data_to_send.item_id = selectedItem._id;
      data_to_send.unit_levels = selectedItem.unit_levels;
      data_to_send.quantity = selectedItem.quantity.map(({ unit, value }) => ({ unit, value:parseInt(value) }));
      data_to_send.expiry_date = v.expiry_date;
      data_to_send.remarks = v.remarks;
      data_to_send.cost_price = v.cost_price;
      data_to_send.selling_price = v.selling_price;

      let url = process.env.REACT_APP_BASEURL + "storesitemstransfer/manual_entry";

      const response = await postSubmitForm(url, data_to_send);
      if (response && response.status === 1) {
        showNotification(response.message, "Success");
        refSelectItem.current.select.clearValue();
        setSelectedRowsUnit([])
        setSelectUnitModal(false)
        refContainer.current.reset();
        if (props.isRefreshData) {
          props.refreshData();
          props.handleClosePopup();
        }
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error, "Error");
    } finally {
      setIsLoading(false)
    }
  };

  const [allItems, setAllItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  const loadAllItems = async () => {
   try {
    preloader(true)
    let url = process.env.REACT_APP_BASEURL + "items/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
       let filtered = response.data?.filter((d)=>d.is_active) || [];
      setAllItems(filtered);
    } else {
      showNotification(response.message, "Error");
    }
   } catch (error) {
    console.log(error);
   } finally {
    preloader(false)
   }
  };

  const [selectUnitModal, setSelectUnitModal] = useState(false)
  function handleSelectItem (selected) {
    setSelectedItem(selected)
    setSelectUnitModal(!selectUnitModal)
  }
  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);
  const [editUnitModal, setEditUnitModal] = useState(false);

  function handleCloseModal() {
    if (selectedRowsUnit && selectedRowsUnit.length > 0) {
        const hasValidQuantity = selectedRowsUnit.every(unit => unit.value > 0);
        if (hasValidQuantity) {
          const updatedProd = { ...selectedItem };
            updatedProd.quantity = selectedRowsUnit;
            setSelectedItem(updatedProd);
          setSelectUnitModal(false);
        }else{
          showNotification("Quantities are not valid","Warning");
        }
    }else{
      setSelectUnitModal(false);
      setSelectedRowsUnit([])
      setSelectedItem({})
    }
}

  function handleToggle() {
      setSelectUnitModal(false);
      setSelectedRowsUnit([])
      setSelectedItem({})
  }

  function handleToggle() {
    setSelectUnitModal(false);
    setEditUnitModal(false)
    setSelectedRowsUnit([])
    // setSelectedItem({})
}
function handleAddQuantity(quantity) {
        const updatedProd = { ...selectedItem };
          let convertedQuantity = GetUpdatedDelivered(quantity,updatedProd.unit_levels)
          updatedProd.quantity=convertedQuantity
        setSelectedItem(updatedProd);
        setSelectUnitModal(false);
}
const handleUpdateQuantity = (quantity) => {
  const updatedProd = { ...selectedItem };
  let convertedQuantity = GetUpdatedDelivered(quantity,updatedProd.unit_levels)
  updatedProd.quantity=convertedQuantity
    setSelectedItem(updatedProd);
    setEditUnitModal(false);
};

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <AvForm
                onValidSubmit={(e, v) => {
                  handleValidSubmit(e, v);
                }}
                ref={refContainer}
              >
                <CardTitle>{props.t("Update Inventory")}</CardTitle>
                <CardSubtitle className="mb-3">
                  {props.t(
                    "Enter the following details to add items to inventory"
                  )}
                </CardSubtitle>
                <Row>
                  <Col lg={6}>
                    <Label>{props.t("Item")}</Label>
                    <Select
                      ref={refSelectItem}
                      value={selectedItem}
                      onChange={(selected) => {
                        handleSelectItem(selected)
                      }}
                      options={allItems}
                      classNamePrefix="select2-selection"
                      components={animatedComponents}
                      required
                    />
                  </Col>
                  {selectedItem?.quantity?.length>0 && (
                    <Col lg={6}>
                    <Label>{props.t("Quantity")}</Label> <br />
                       {formatUnitsForReport(selectedItem?.quantity) }
                       <Button
                  className="btn btn-success waves-effect waves-light btn-sm ms-5"
                  onClick={() => {
                    setEditUnitModal(!editUnitModal);
                  }}
                >
                  <i class="mdi mdi-edit"></i>
                  {props.t("Edit")}
                </Button>
                  </Col>
                  )}
                  <Col lg={6}>
                    <Label>
                      {props.t("Cost Price")}
                      {selectedItem && " (per " + selectedItem.unit_for_po + ")"}
                    </Label>
                    <AvField
                      name="cost_price"
                      placeholder={props.t("Enter Cost Price")}
                      type="text"
                      value={Number(selectedItem?.latest_cost_price || 0)}
                      disabled
                       validate={{
                        pattern: {
                          value: /^(0|[1-9]\d*)(\.\d+)?$/,
                          errorMessage: props.t("Only numbers are allowed."),
                        },
                        // min: {
                        //   value: 0.1,
                        //   errorMessage: props.t("Price must be greater than or equal to 0.1"),
                        // },
                        required:{value:true,errorMessage: props.t("cost price is required."),
                        }
                      }}
                    />
                  </Col>
                  <Col lg={6}>
                    <Label>
                      {props.t("Selling Price")}
                      {selectedItem?.unit && " (per " + selectedItem.unit + ")"}
                    </Label>
                    <AvField
                      name="selling_price"
                      placeholder={props.t("Enter Selling Price")}
                      type="text"
                      value={selectedItem && selectedItem.selling_price}
                      validate={{
                        pattern: {
                          value: /^(0|[1-9]\d*)(\.\d+)?$/,
                          errorMessage: props.t("Only numbers are allowed."),
                        },
                      }}
                    />
                  </Col>
                  <Col lg={6}>
                    <AvField
                      name="expiry_date"
                      label={props.t("Expiry Date") + " *"}
                      placeholder={props.t("Select Expiry Date")}
                      type="date"
                      min={currentDate}
                      required
                      errorMessage="Expiry date cannot be empty"
                    />
                  </Col>
                  <Col lg={6}>
                    <AvField
                      name="remarks"
                      label={props.t("Remarks")}
                      placeholder={props.t("Enter Remarks")}
                      type="textarea"
                    />
                  </Col>
                  <Col lg={12}>
                    <hr />
                    <FormGroup className="mb-0 text-center">
                      <div>
                        <Button type="submit" color="primary" className="mr-1" disabled={isLoading} style={{width:"100px"}}>
                          { isLoading ? <Spinner size={"sm"}/> :props.t("Submit")}
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </AvForm>
            </CardBody>
          </Card>

             {/* Add quanity modal  */}
      <EnterQuantityForManualInventory
        isOpen={selectUnitModal}
        toggle={handleToggle}
        onSubmit={handleAddQuantity}
        item={selectedItem}
        checkLimitFor={""}
      />

 {/* Edit quantity modal  */}
          <UpdateQuantityForManualInventory
                   isOpen={editUnitModal}
                   toggle={handleToggle}
                   onSubmit={handleUpdateQuantity}
                   item={selectedItem}
                  />
        </Col>
      </Row>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(AddInventory))
);
